<template>
  <div id="app" class="legal-page page-template-default page wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
    <HeadNav selectedLanguage="en" :page="pageName" :gotodownload="gotodownload" :apk="apk" />

    <div id="page" class="site grid-container container hfeed">
      <div id="content" class="site-content">
        <div id="primary" class="content-area">
          <main id="maincontent" class="site-main">
            <article class="legal-article">
              <header class="legal-header">
                <h1 class="entry-title" itemprop="headline">{{ title }}</h1>
                <p v-if="subtitle" class="legal-subtitle">{{ subtitle }}</p>
              </header>

              <div class="legal-content" itemprop="text">
                <p v-if="intro">{{ intro }}</p>

                <section v-for="(section, index) in sections" :key="index" class="legal-section">
                  <h2>{{ section.heading }}</h2>
                  <p v-for="(paragraph, paragraphIndex) in section.paragraphs" :key="paragraphIndex">{{ paragraph }}</p>
                  <ul v-if="section.items && section.items.length">
                    <li v-for="(item, itemIndex) in section.items" :key="itemIndex">{{ item }}</li>
                  </ul>
                </section>

                <section v-if="email" class="legal-section contact-section">
                  <h2>Contact</h2>
                  <p>For questions about this page, email us at <a :href="'mailto:' + email">{{ email }}</a>.</p>
                </section>
              </div>
            </article>
          </main>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'LegalPage',
  components: {
    HeadNav,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    intro: {
      type: String,
      default: '',
    },
    sections: {
      type: Array,
      default: () => [],
    },
    email: {
      type: String,
      default: '',
    },
    pageName: {
      type: String,
      default: 'privacy',
    },
  },
  data() {
    return {
      apk: null,
    };
  },
  methods: {
    gotodownload() {
      if (typeof window !== 'undefined') {
        window.location.href = '/download-apk/';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.legal-page {
  min-height: 100vh;
  padding-bottom: 80px;
  box-sizing: border-box;
  background: #f5f7fa;
}

.legal-page .site-content,
.legal-page .content-area,
.legal-page .site-main {
  display: block;
  height: auto;
  min-height: 0;
}

.legal-article {
  width: min(920px, calc(100% - 30px));
  margin: 28px auto 0;
  background: #fff;
  border-radius: 8px;
  padding: 34px 40px;
  box-shadow: 0 8px 24px rgba(31, 53, 86, 0.08);
}

.legal-header {
  margin-bottom: 28px;
}

.entry-title {
  margin: 0 0 8px;
  font-size: 34px;
  line-height: 1.25;
  color: #14213d;
  letter-spacing: 0;
}

.legal-subtitle {
  margin: 0;
  color: #64748b;
  font-size: 15px;
}

.legal-content {
  color: #28364a;
  font-size: 16px;
  line-height: 1.75;
}

.legal-section {
  margin-top: 26px;
}

.legal-section h2 {
  margin: 0 0 10px;
  color: #14213d;
  font-size: 22px;
  font-weight: 650;
}

.legal-section p {
  margin: 0 0 12px;
}

.legal-section ul {
  margin: 8px 0 14px 20px;
  padding-left: 0;
}

.legal-section a {
  color: #1677d2;
  text-decoration: none;
}

.legal-section a:hover {
  text-decoration: underline;
}

.contact-section {
  padding-top: 22px;
  border-top: 1px solid #e5e7eb;
}

@media (max-width: 768px) {
  .legal-page {
    padding-bottom: 64px;
  }

  .legal-article {
    margin-top: 16px;
    padding: 24px 18px;
  }

  .entry-title {
    font-size: 28px;
  }

  .legal-section h2 {
    font-size: 20px;
  }
}
</style>
